import Image from 'next/image';
import hero from '../assets/donors/hero.jpg';
import { Button } from '../components/general/button';
import { BlueArch, WhiteArch } from '../components/img/svgs';
import { Meta } from '../components/meta/meta';

import img1 from '../assets/donors/donors1.jpeg';
import img2 from '../assets/donors/donors2.jpeg';
import img3 from '../assets/donors/donors3.jpeg';

export default function CommunityDonors() {
  return (
    <main>
      <Meta title="community donors" description="Beds for Kids Community Donors" noDefaultFooter />
      <section className="relative h-[70vh] w-full overflow-hidden">
        <Image
          alt="Beds for Kids Corporate Volunteers"
          src={hero}
          className="absolute z-0 h-full w-full object-cover"
          sizes="100vw"
          priority
        />
        <div className="pointer-events-none absolute -bottom-[1px] left-0 right-0">
          <WhiteArch />
        </div>
      </section>
      <section className="bg-white pb-12 text-blue-500">
        <h1 className="mx-auto my-4 max-w-3xl text-center font-operetta text-6xl">community donors</h1>
        <p className="mx-auto max-w-3xl px-4 text-center font-avenir text-xl leading-6">
          Beds for Kids has deep connections with our community and embraces any groups and organizations willing to
          donate their time, money and good will towards helping support those in the Charlotte area who are in need of
          a place to call home.
        </p>
      </section>
      <section className="flex flex-col items-center bg-white pb-12 text-blue-500">
        <div className="grid max-w-3xl gap-x-12 gap-y-8 px-4 pb-8 font-avenir md:grid-cols-2">
          <div>
            <h3 className="text-center text-3xl font-medium leading-8 md:text-left">
              organizations we
              <br />
              work with
            </h3>
            <ul className="ml-12 mt-4 flex list-disc flex-col gap-1">
              <li className="text-lg leading-6">Rotary Clubs</li>
              <li className="text-lg leading-6">Churches</li>
              <li className="text-lg leading-6">Schools</li>
              <li className="text-lg leading-6">Youth Groups</li>
              <li className="text-lg leading-6">National Charity League</li>
            </ul>
          </div>
          <div>
            <h3 className="text-center text-3xl font-medium leading-8 md:text-left">
              ways organizations
              <br />
              can give back
            </h3>
            <ul className="ml-12 mt-4 flex list-disc flex-col gap-1">
              <li className="text-lg leading-6">Volunteer at the warehouse</li>
              <li className="text-lg leading-6">Go on a delivery</li>
              <li className="text-lg leading-6">Organize a sheet, blanket or pillow drive</li>
              <li className="text-lg leading-6">Spearhead a furniture drive in your neighborhood</li>
              <li className="text-lg leading-6">Donate furniture or funds to further our mission</li>
            </ul>
          </div>
        </div>
        <div className="text-center">
          <Button link="/contact#form">get involved</Button>
        </div>
      </section>
      <section className="flex flex-col items-center bg-white pb-12 pt-4 text-blue-500">
        <div className="mx-4 grid w-full max-w-6xl gap-4 md:grid-cols-3">
          <Image
            src={img1}
            alt="Beds for Kids volunteers in front of a truck"
            className="relative aspect-[16/9] w-full overflow-hidden object-cover object-[0_50%]"
            sizes="100vw, (min-width: 768px) 33vw"
          />
          <Image
            src={img2}
            alt="Beds for Kids volunteers sitting in the warehouse"
            className="relative aspect-[16/9] w-full overflow-hidden object-cover object-[0_60%]"
            sizes="100vw, (min-width: 768px) 33vw"
          />
          <Image
            src={img3}
            alt="Beds for Kids volunteers holding pillows"
            className="relative aspect-[16/9] w-full overflow-hidden object-cover object-[0_50%]"
            sizes="100vw, (min-width: 768px) 33vw"
          />
        </div>
      </section>
      <BlueArch />
      <section className="bg-blue-500 pb-12 pt-4 text-center text-white">
        <div className="mx-auto max-w-3xl px-4">
          <h2 className="font-operetta text-5xl">get your organization involved</h2>
          <h6 className="mt-8 font-avenir text-2xl font-medium">Think you might be a good fit for Beds for Kids?</h6>
          <p className="mt-8 font-avenir text-lg leading-6">
            Head over to the contact page and tell us a little bit about your organization and ways to help.
          </p>
          <div className="mt-8 text-center">
            <Button link="/contact#form" bType="secondary-white">
              contact us now!
            </Button>
          </div>
        </div>
      </section>
    </main>
  );
}
